import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditMenuComponent } from './edit-menu.component';

import { jqxTreeModule } from 'jqwidgets-ng/jqxtree';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';

@NgModule({
  declarations: [EditMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxTreeModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxGridModule,
  ],
  exports: [EditMenuComponent],
})
export class EditMenuModule {}
